import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { apiClient } from "@/lib/auth";

const OFF_CONFIRM = "This hides the old-portal comparison on every resident file. Residents not yet reconciled will lose that check. Continue?";

/** Super admin only: one platform-wide switch for the old-portal comparison panel. */
export function OldPortalToggle({ onChange }) {
  const [s, setS] = useState(null);
  useEffect(() => { apiClient.get("/platform-settings/old-portal").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s?.can_edit) return null;
  const flip = async () => {
    const next = !s.enabled;
    if (!next && !window.confirm(OFF_CONFIRM)) return;
    try {
      await apiClient.put("/platform-settings/old-portal", { enabled: next });
      setS({ ...s, enabled: next });
      toast.success(next ? "Old-portal comparison shown" : "Old-portal comparison hidden");
      onChange?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Couldn't save"); }
  };
  return (
    <label className="flex items-start gap-2 text-xs text-nex-silver cursor-pointer" data-testid="old-portal-toggle-row">
      <input type="checkbox" checked={!!s.enabled} onChange={flip} data-testid="old-portal-toggle" className="mt-0.5 accent-amber-400" />
      <span><span className="font-medium">Show old-portal comparison</span>
        <span className="block text-[11px] text-nex-muted">Turn off once old-portal reconciliation is finished. Data is kept and you can turn it back on.</span></span>
    </label>
  );
}
